import { useLocation } from 'react-router-dom'

import { parseSearchParams } from '../../utils/url.utils.js'

export const useQuery = <T = Record<string, string>>(): T => {
  return parseSearchParams<T>(useLocation().search)
}
